function LicenseActionsCtrl($scope, $timeout) {
    $scope.triggerLicenseActivationJobRequest = {
        result: null,
    };
    $scope.triggerLicenseActivationJob = function () {
        return new Promise(() => {
            $scope.disableButton = true;
            return store.fetch({
                method: 'POST',
                url: '/triggerLicenseActivationJob',
                success: function success(data) {
                    $timeout(function () {
                        $scope.triggerLicenseActivationJobRequest.result = data;
                        $scope.$root.showNotification('success', "License activation job triggered successfully");
                    }, 0);
                },
                error: function error(data) {
                    $scope.triggerLicenseActivationJobRequest.result = data;
                    $scope.$root.showNotification('error', "License activation job failed to trigger");
                    $scope.disableButton = false;
                }
            });
        });
    };
}